// =====================================================================
// clinicDashboardService (Dashboard Gestão / D1 / S88) — chamadas axios
// pra API /clinic-dashboard/*. isAuth no backend; escopo = clínica ativa
// (companyId do JWT). Read-only.
// =====================================================================
import api from "./api";

const qp = (start, end) => {
  const params = {};
  if (start) params.start = start;
  if (end) params.end = end;
  return { params };
};

export const getSummary = async (start, end) =>
  (await api.get("/clinic-dashboard/summary", qp(start, end))).data;
export const getFunnel = async (start, end) =>
  (await api.get("/clinic-dashboard/funnel", qp(start, end))).data;
export const getStatus = async (start, end) =>
  (await api.get("/clinic-dashboard/status", qp(start, end))).data;
export const getMonthly = async () =>
  (await api.get("/clinic-dashboard/monthly")).data;
export const getByDoctor = async (start, end) =>
  (await api.get("/clinic-dashboard/by-doctor", qp(start, end))).data;
export const getSources = async (start, end) =>
  (await api.get("/clinic-dashboard/sources", qp(start, end))).data;
export const getIaVsHuman = async (start, end) =>
  (await api.get("/clinic-dashboard/ia-vs-human", qp(start, end))).data;
export const getWaitTime = async (start, end) =>
  (await api.get("/clinic-dashboard/wait-time", qp(start, end))).data;
export const getDemographics = async (start, end) =>
  (await api.get("/clinic-dashboard/demographics", qp(start, end))).data;
export const getInsights = async (start, end) =>
  (await api.get("/clinic-dashboard/insights", qp(start, end))).data;
// [S112] Lista de faltosos (no-show) pra recuperação — recepção acessa.
export const getNoShows = async (start, end) =>
  (await api.get("/clinic-dashboard/no-shows", qp(start, end))).data;
// [S112] Recepção marca o desfecho da recuperação (reagendou / não conseguiu).
export const setNoShowRecovery = async (id, status, note) =>
  (await api.post(`/clinic-dashboard/no-shows/${id}/recovery`, { status, note })).data;
